import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-child-abuse-form',
  templateUrl: './child-abuse-form.component.html',
  styleUrls: ['./child-abuse-form.component.scss']
})
export class ChildAbuseFormComponent implements OnInit {
	childAbuseForm: FormGroup;
  @Output() hasValidChildAbuse = new EventEmitter<boolean>();
	@Output() data = new EventEmitter();
	constructor(private _formBuilder: FormBuilder) { }

	ngOnInit(): void {
    this.childAbuseForm = this._formBuilder.group({
      HasOpenJuvenileCase: [null],
      dateOfIncident: [null],
      socialWorkerName: [''],
      socialWorkerPhone: [''],
      HasSuspicionChildAbuse: [null],
      childAbuseInfo: [''],
      HasSubstanceUse: [null],
      substanceInfo: [''],
      HasFirearms: [null],
      firearmsInfo: [''],
      HasCriminalHist: [null],
      criminalInfo: [''],
      HasPendingCriminal: [null],
      pendingCriminalInfo: ['']

		});
    this.hasValidChildAbuse.emit(this.childAbuseForm.valid);
    this.childAbuseForm.statusChanges.subscribe((res) => {
      this.hasValidChildAbuse.emit(this.childAbuseForm.valid);
		})
    this.childAbuseForm.valueChanges.subscribe(res => {
			this.data.emit(res);
    })

    this.childAbuseForm.get('HasOpenJuvenileCase').valueChanges.subscribe((value) => {
      this.toggleFormField('HasOpenJuvenileCase', value);
    });

    this.childAbuseForm.get('HasSuspicionChildAbuse').valueChanges.subscribe((value) => {
      this.toggleFormField('HasSuspicionChildAbuse', value);
    });

    this.childAbuseForm.get('HasSubstanceUse').valueChanges.subscribe((value) => {
      this.toggleFormField('HasSubstanceUse', value);
    });

    this.childAbuseForm.get('HasFirearms').valueChanges.subscribe((value) => {
      this.toggleFormField('HasFirearms', value);
    });

    this.childAbuseForm.get('HasCriminalHist').valueChanges.subscribe((value) => {
      this.toggleFormField('HasCriminalHist', value);
    });

    this.childAbuseForm.get('HasPendingCriminal').valueChanges.subscribe((value) => {
      this.toggleFormField('HasPendingCriminal', value);
    });
  }

  private toggleFormField(fieldName: string, condition: string): void {
    const fieldMappings = {
      HasOpenJuvenileCase: ['dateOfIncident', 'socialWorkerName', 'socialWorkerPhone'],
      HasSuspicionChildAbuse: ['childAbuseInfo'],
      HasSubstanceUse: ['substanceInfo'],
      HasFirearms: ['firearmsInfo'],
      HasCriminalHist: ['criminalInfo'],
      HasPendingCriminal: ['pendingCriminalInfo']
    };

    const controls = fieldMappings[fieldName];

    if (controls) {
      controls.forEach(controlName => {
        const control: AbstractControl = this.childAbuseForm.get(controlName);

        if (condition === 'true') {
          control.enable();
          control.setValidators([Validators.required]);
        } else {
          control.disable();
          control.clearValidators();
          control.reset({ value: '', disabled: true });
        }

        control.updateValueAndValidity();
      });
    }
  }
}
